module.exports = __webpack_public_path__ + "img/UTKODA-4.e712483a.jpg";